<template>
    <div>
        <ValidationObserver ref="observer">
            <b-card>
                <b-row
                    ><b-col>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors, validate }"
                            name="location"
                        >
                            <GmapAutocomplete
                                @place_changed="placechange1"
                                @change="validate"
                                placeholder="Enter Your Location *"
                                :options="{
                                    fields: [
                                        'geometry',
                                        'formatted_address',
                                        'address_components',
                                    ],
                                }"
                                class="mt-1 location-search"
                            ></GmapAutocomplete>
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col md="6">
                        <ValidationProvider
                            rules="required|min:3|alpha_spaces"
                            v-slot="{ errors }"
                            name="company name"
                        >
                            <c-input
                                inputType="text"
                                labelText="Company Name *"
                                v-model="basicInfo.name"
                            />
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Country"
                        >
                            <c-input
                                labelText="Country *"
                                inputType="text"
                                v-model="basicInfo.address.country"
                            ></c-input>
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="State"
                        >
                            <c-input
                                labelText="State *"
                                inputType="text"
                                v-model="basicInfo.address.state"
                            ></c-input>
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="city"
                        >
                            <c-input
                                labelText="City *"
                                inputType="text"
                                v-model="basicInfo.address.city"
                            ></c-input>
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row class="my-2"
                    ><b-col>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="street 1"
                        >
                            <b-form-textarea
                                class="product-textarea"
                                debounce="1000"
                                placeholder="Street Line 1 *"
                                rows="4"
                                no-resize
                                v-model="basicInfo.address.street1"
                            ></b-form-textarea>
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider> </b-col
                    ><b-col>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="street 2"
                        >
                            <b-form-textarea
                                class="product-textarea"
                                debounce="1000"
                                placeholder="Street Line 2 *"
                                rows="4"
                                v-model="basicInfo.address.street2"
                                no-resize
                            ></b-form-textarea
                            ><span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col></b-row
                >
                <b-row class="mt-2">
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Building number"
                        >
                            <c-input
                                type="text"
                                labelText="Building No. *"
                                v-model="basicInfo.address.houseNumber"
                            />
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider
                            v-slot="{ errors }"
                            rules="required"
                            name="zipcode"
                        >
                            <c-input
                                inputType="number"
                                v-model="basicInfo.address.zip"
                                labelText="Zipcode *"
                            />
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row></b-card
            >
            <slot name="footer-button" :data="basicInfo"> </slot>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import locationMixins from "@/mixins/addressLocation";
export default {
    name: "basicInfoStepper",
    mixins: [locationMixins],
    data() {
        return {
            countries: [],
            states: [],
            cities: [],
            basicInfo: {
                name: "",
                address: {
                    country: "",
                    state: "",
                    city: "",
                    location: {
                        coordinates: [0, 0],
                    },
                    street1: "",
                    street2: "",
                    zip: "",
                    houseNumber: "",
                },
            },
        };
    },
    components: {
        cInput,
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        isValid() {
            const isValid = this.$refs.observer.validate();
            return isValid;
        },
        async placechange1(e) {
            let extractData = await this.placechange(e);
            if (Object.keys(extractData).length != 0) {
                if (extractData.data.Country) {
                    this.basicInfo.address.country = extractData.data.Country;
                }
                if (extractData.data.State) {
                    this.basicInfo.address.state = extractData.data.State;
                }
                if (extractData.data.zip) {
                    this.basicInfo.address.zip = extractData.data.zip;
                }
                if (extractData.data.City) {
                    this.basicInfo.address.city = extractData.data.City;
                }
                if (extractData.Lat && extractData.Lng) {
                    this.basicInfo.address.location = {
                        lat: extractData.Lat,
                        lng: extractData.Lng,
                    };
                }
            }
        },
    },
};
</script>
<style>
.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato", sans-serif !important;
    font-weight: 500;
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: 14px;
}
.validate-error-red {
    color: red;
}
.product-textarea {
    font-family: "Lato", sans-serif !important;
}

/* Optional: If you want the placeholder to match exactly */
.product-textarea::placeholder {
    font-family: "Lato", sans-serif;
    font-weight: 600;
    font-size: 14px;
}
</style>
